import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { verifyToken, getToken } from './auth';
import Gatekeeper from './components/Gatekeeper';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChatbotTerminal from './components/chatbot/ChatbotTerminal';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Career from './pages/Career';
import Partners from './pages/Partners';
import SupportandComunities from './pages/SupportandComunities';
import Reviews from './pages/MediaandReviews';
import './styles/App.css';

/**
 * Scroll to top on route change
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

/**
 * Main App Component
 * Handles routing and authentication
 */
function App() {
  const [authCheck, setAuthCheck] = useState(false);
  const [hasToken, setHasToken] = useState(false);
  const [isAppLoading, setIsAppLoading] = useState(true);

  // On mount, verify token validity
  useEffect(() => {
    const verifyUserToken = async () => {
      const token = getToken();
      if (token) {
        const isValid = await verifyToken(token);
        setHasToken(isValid);
      }
      setAuthCheck(true);
    };

    verifyUserToken();
  }, []);

  // App preloader (logo + progress style)
  useEffect(() => {
    const timer = setTimeout(() => setIsAppLoading(false), 1700);
    return () => clearTimeout(timer);
  }, []);

  // Scroll percentage indicator
  // useEffect(() => {
  //   const updateScrollProgress = () => {
  //     const scrollTop = window.pageYOffset;
  //     const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  //     const scrolled = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
  //     setScrollProgress(Math.min(100, Math.max(0, scrolled)));
  //   };

  //   window.addEventListener('scroll', updateScrollProgress, { passive: true });
  //   updateScrollProgress();

  //   return () => window.removeEventListener('scroll', updateScrollProgress);
  // }, []);

  // App preloader (logo, progress, and text effect)
  if (isAppLoading) {
    return (
      <div className="app-preloader">
        <img
          src="https://res.cloudinary.com/dwdkccvnz/image/upload/v1772120373/logo_m30til.png"
          alt="incogniflex logo"
          className="preloader-logo"
        />
        <div className="preloader-dots">⠋⠙⠹⠸⠼⠴⠦⠧⠇⠏</div>
        {/* <div className="preloader-percent">Loading 100%</div> */}
      </div>
    );
  }

  if (!authCheck) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!hasToken) {
    return (
      <Router>
        <Gatekeeper />
      </Router>
    );
  }

  return (
    <Router>
      <ScrollToTop />
      <div className="app">

        <Navbar />

        {/* Main Content */}
        <main className="main-content with-navbar">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/support" element={<SupportandComunities />} />
            <Route path="/career" element={<Career />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        <Footer />

        {/* Chatbot terminal - always visible */}
        {/* <ChatbotTerminal /> */}
      </div>
    </Router>
  );
}

export default App;
